import { init } from './init';
import { get, count, getAll } from './get';
import { add, addGroup } from './set';
import { findAndModify } from './update';
import { clearTable, clear, del } from './delete';

export default {
    init,
    get,
    add,
    clearTable,
    clear,
    count,
    findAndModify,
    addGroup,
    del,
    getAll
};
